import { ChainId } from '@nevellusdex/core-sdk'

const THE_GRAPH = 'https://api.thegraph.com'
const NAS_GRAPH = 'https://graph.kkt.one/node'
const HYPER_GRAPH = 'https://q.hg.network'

export const GRAPH_HOST = {
  [ChainId.ETHEREUM]: THE_GRAPH,
  [ChainId.GÖRLI]: THE_GRAPH,
  [ChainId.XDAI]: THE_GRAPH,
  [ChainId.MATIC]: THE_GRAPH,
  [ChainId.MATIC_TESTNET]: THE_GRAPH,
  [ChainId.CELO]: THE_GRAPH,
  [ChainId.HARMONY]: THE_GRAPH,
  [ChainId.FUSE]: THE_GRAPH,
}

export const TRIDENT = {
  // [ChainId.MATIC]: 'nevellus-labs/trident-polygon',
  // [ChainId.KOVAN]: 'nevellus-labs/trident-kovan',
}
